export enum AddressValidationResult {
    Valid = 1,
    MultipleAddresses = 2,
    Recommendation = 3,
    POBoxNotAllowed = 4,
    Other = 5,
    InvalidRequest = 6,
    FatalError = 99
}